/** @format */

import COLORS from '../../colors';
import { blackColor, hexToRgb, title, whiteColor } from '../../../../jss/material-dashboard-pro-react';

const loginPageStyle: any = {
    loginPageContainer: {
        paddingRight: '15px',
        paddingLeft: '15px',
        marginRight: 'auto',
        marginLeft: 'auto',
        '@media (min-width: 768px)': {
            width: '750px',
        },
        '@media (min-width: 992px)': {
            width: '970px',
        },
        '@media (min-width: 1200px)': {
            width: '1170px',
        },
        // '&:before,&:after': {
        //     display: 'table',
        //     content: '" "',
        // },
        '&:after': {
            clear: 'both',
        },
        zIndex: '4',
    },
    cardTitle: {
        textDecoration: 'none',
        '& small': {
            color: COLORS.MAIN.LIGHT,
            fontWeight: '400',
            lineHeight: '1',
        },
        marginTop: '0',
        marginBottom: '3px',
        minHeight: 'auto',
        '& a': {
            marginTop: '.625rem',
            marginBottom: '0.75rem',
            minHeight: 'auto',
        },
        color: COLORS.MAIN.LIGHT,
    },
    textCenter: {
        textAlign: 'center',
    },
    justifyContentCenter: {
        justifyContent: 'center !important',
    },
    fullWidth: {
        width: '100%',
    },
    customButtonClass: {
        '&,&:focus,&:hover': {
            color: COLORS.MAIN.LIGHT,
        },
        marginLeft: '5px',
        marginRight: '5px',
    },
    inputAdornment: {
        marginRight: '18px',
    },
    inputAdornmentIcon: {
        color: COLORS.MAIN.DARK,
    },
    cardHidden: {
        opacity: '0',
        transform: 'translate3d(0, -60px, 0)',
    },
    socialLine: {
        padding: '0.9375rem 0',
    },
};

export default loginPageStyle;
